// libs
import React, {useContext, useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import axios from "../../axios-defaults";
import UserContext from "../../context/user-context";

// Components
import PageTitle from "../../components/Commons/PageTitle";
import TanksList from "../../components/Tanks/TanksList"

const Tanks = (props) => {
    const { t } = useTranslation();
    const userContext = useContext(UserContext);

    const [loading, setLoading] = useState(null);
    const [filteredTanks, setFilteredTanks] = useState(null);
    const [subAccounts, setSubAccounts] = useState(null);
    const [allowedSubAccountCodes, setAllowedSubAccountCodes] = useState([]);

    const getSubaccounts = async () => {
        return await axios.get("/accounts/subaccounts")
            .then(response => {
                if (response.data.succeeded) {
                    let cleaned = response.data.data.filter(elem => elem.subAccountDisplayMode.code === 'L');
                    return cleaned;
                } else { return []; }
            }).catch(error => {
                console.log('[tanks.jsx] : Ajax error in getSubaccounts()', error.message);
                return [];
            });
    };

    const getAllTanksWithReadingDevices = async (handleLoading = false) => {
        if(handleLoading){ setLoading(true); }
        return await axios.get("/accounts/tanksWithDipReadingDevice", {
                params: { pageSize: -1 }
            })
            .then(response => {
                if(handleLoading){ setLoading(false); }
                if (response.data.succeeded){
                    return response.data.data
                } else { return []; }
            }).catch(error => {
                console.log('[tanks.jsx] : Ajax error in getAllTanksWithReadingDevices()', error.message);
                if(handleLoading){ setLoading(false); }
                return [];
            });
    }

    // Filtrer les tanks selon les permissions de l'utilisateur
    const filterTanksByPermissions = (tanksToFilter, codes, user) => {
        if (!tanksToFilter || !Array.isArray(tanksToFilter)) {
            return [];
        }

        // Si l'utilisateur est propriétaire, admin ou a des permissions complètes, pas de filtrage
        if (user && (user.is_account_owner ||
            user.permission === 'complete' )) {
            return tanksToFilter;
        }

        // S'il n'y a pas de codes ou si l'utilisateur n'a pas le statut "limited", retourner une liste vide
        if (!codes || !Array.isArray(codes) || codes.length === 0) {
            return [];
        }

        // Filtrer les tanks selon les codes de sous-comptes autorisés
        const filtered = tanksToFilter.filter(tank => {
            const tankCode = tank.subAccountCode.toString();
            const isAllowed = codes.includes(tankCode);
            return isAllowed;
        });

        return filtered;
    }

    useEffect(() => {
        const initData = async () => {
            setLoading(true);

            const user = userContext.user.infos;

            if (!user) {
                setLoading(false);
                return;
            }

            // Récupérer tous les réservoirs
            const tanksData = await getAllTanksWithReadingDevices();

            // Récupérer tous les sous-comptes
            const subAccsData = await getSubaccounts();
            setSubAccounts(subAccsData);

            // Pour les utilisateurs limités, obtenir les sous-comptes autorisés
            if (user.permission === 'limited') {
                let allowedCodes = user.allowed_subaccounts || [];

                if (Array.isArray(allowedCodes)) {
                    allowedCodes = allowedCodes.map(code => code.toString());
                }

                setAllowedSubAccountCodes(allowedCodes);

                // Filtrer les réservoirs
                const filteredData = filterTanksByPermissions(tanksData, allowedCodes, user);
                setFilteredTanks(filteredData);
            } else {
                // Pour les utilisateurs non limités
                setFilteredTanks(tanksData);
            }

            setLoading(false);
        };

        initData();
    }, [userContext]);

    const reloadData = async () => {
        setLoading(true);
        const newTanks = await getAllTanksWithReadingDevices();
        const userInfo = userContext.user.infos;

        if (userInfo && userInfo.permission === 'limited' && !userInfo.is_account_owner && !userInfo.can_personify) {
            setFilteredTanks(filterTanksByPermissions(newTanks, allowedSubAccountCodes, userInfo));
        } else {
            setFilteredTanks(newTanks);
        }

        setLoading(false);
    };

    return (
        <>
            <div className="container container--larger">
                <PageTitle title={t('breadcrumbs.tanks')} />
                <TanksList initialData={ filteredTanks || [] }
                           subAccounts={ subAccounts }
                           reloadData={ reloadData }
                           loading={ loading }
                           refreshTabs={ null }
                           changeDateFilter={ null } />
            </div>
        </>
    );
};

export default Tanks;
